function clamp(_ref) {
  var value = _ref.value,
    min = _ref.min,
    max = _ref.max;
  return Math.min(Math.max(value, min), max);
}
export { clamp };